import { IconSearch } from "@tabler/icons-react";

/**
 * Botón del header que abre la command palette · despacha el mismo
 * `KeyboardEvent` (Ctrl+K) que el atajo global, así la palette solo
 * necesita escuchar teclado (single source, ver `use-command-palette-shortcut.ts`).
 */
export function SearchTrigger() {
  function dispararCtrlK() {
    window.dispatchEvent(new KeyboardEvent("keydown", { key: "k", ctrlKey: true }));
  }
  return (
    <button
      type="button"
      onClick={dispararCtrlK}
      aria-label="Buscar por folio, proveedor o RFC (Ctrl+K)"
      className={[
        // En móvil es un botón solo-ícono (sin `flex-1`, se encoge a su contenido)
        // para no deformar el header; desde sm crece a la barra completa.
        "flex h-[34px] shrink-0 items-center gap-2 rounded-xl border px-2.5 text-xs text-muted-foreground transition-colors shadow-2xs",
        "sm:max-w-[520px] sm:flex-1 sm:px-3",
        "border-border bg-muted/50 hover:border-ink-300 hover:bg-muted",
      ].join(" ")}
    >
      <IconSearch size={15} stroke={1.6} className="shrink-0" />
      {/* El texto no hace wrap (truncate) para no romper la altura del pill; se
          oculta por completo en móvil, donde el botón queda solo-ícono. */}
      <span className="hidden flex-1 truncate text-left sm:block">Buscar por folio, proveedor o RFC…</span>
      <span className="ml-auto hidden font-mono text-[11px] text-muted-foreground sm:inline">(Ctrl+K)</span>
    </button>
  );
}
